// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"efc37ecb","703":"833f53d1"}[chunkId] + ".chunk.js";
};